export default function fetchResultsSet(query, setID, callback) {
  const request = new XMLHttpRequest();

  request.open('GET', `${__config.api_path}${setID}?` + query.toString(['units']), true);

  request.onload = function () {
    if (request.status >= 200 && request.status < 400) {
      callback(setID, JSON.parse(request.responseText));
    }
  };

  request.send();
}
